import Vue from "vue";

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
    faUserSecret,
    faChartPie,
    faCloudUpload,
    faWaveSquare,
    faImage,
    faMicrophone,
    faMobile,
    faMobileScreen,
    faAnchor,
    faStethoscope,
    faChartArea,
    faServer,
    faMicrochip,
    faImages,
    faRightFromBracket,
    faCircle,
    faCircleCheck,
    faLinkSlash,
    faLink,
    faArrowsRotate,
    faArrowUpWideShort,
    faArrowDownWideShort,
    faChartLine,
    faFileAudio,
    faCircleExclamation,
    faGears,
    faCirclePlay,
    faCirclePause,
    faCaretLeft,
    faCaretRight,
    faCircleStop,
    faBook,
    faBookMedical,
    faLanguage,
    faFan,
    faClock,
    faLineChart,
    faCheckToSlot,
    faBusinessTime,
    faCalendarCheck,
    faCalendarWeek,
    faWind,
    faCubesStacked,
    faExpand,
    faCompress,
    faPaperPlane,
    faArrowUpRightFromSquare,
    faArrowUpShortWide,
    faUpload,
    faDownload,
    faDice,
    faFilter,
    faLayerGroup,
    faPenToSquare,
    faNetworkWired,
    faVolumeHigh,
} from '@fortawesome/free-solid-svg-icons'


library.add(faUserSecret,
    faChartPie,
    faCloudUpload,
    faWaveSquare,
    faImage,
    faMicrophone,
    faMobile,
    faAnchor,
    faStethoscope,
    faChartArea,
    faServer,
    faMicrochip,
    faImages,
    faRightFromBracket,
    faCircle,
    faCircleCheck,
    faLinkSlash,
    faLink,
    faArrowsRotate,
    faArrowDownWideShort,
    faArrowUpShortWide,        
    faChartLine,
    faFileAudio,
    faCircleExclamation,
    faGears,
    faCirclePlay,
    faCirclePause,
    faCircleStop,
    faCaretLeft,
    faCaretRight,
    faBook,
    faBookMedical,
    faLanguage,
    faFan,
    faClock,
    faLineChart,
    faCheckToSlot,
    faBusinessTime,
    faCalendarCheck,
    faCalendarWeek,
    faWind,
    faCubesStacked,
    faExpand,
    faCompress,
    faPaperPlane,
    faMobileScreen,
    faArrowUpRightFromSquare,
    faUpload,
    faDownload,
    faDice,
    faFilter,
    faLayerGroup,
    faPenToSquare,
    faNetworkWired,
    faVolumeHigh
)
Vue.component('font-awesome-icon',
    FontAwesomeIcon)
